import { createContext, type ReactNode, useContext, useState } from "react";

type LinkedInContextValue = {
	isAuthenticated: boolean | null; // null = checking, false = not authenticated, true = authenticated
	user: object | null; // LinkedIn user data if authenticated
	setAuthState: (authenticated: boolean, user: object | null) => void;
};

const LinkedInContext = createContext<LinkedInContextValue | undefined>(
	undefined,
);

export const LinkedInProvider = ({ children }: { children: ReactNode }) => {
	const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
	const [user, setUser] = useState<object | null>(null);

	const setAuthState = (authenticated: boolean, userData: object | null) => {
		setIsAuthenticated(authenticated);
		setUser(userData);
	};

	return (
		<LinkedInContext.Provider value={{ isAuthenticated, user, setAuthState }}>
			{children}
		</LinkedInContext.Provider>
	);
};

export const useLinkedIn = () => {
	const ctx = useContext(LinkedInContext);
	if (!ctx) throw new Error("useLinkedIn must be used inside LinkedInProvider");
	return ctx;
};
